import messagesReducer from "./messagesSlice";

export default messagesReducer;
